// Synthesized call sounds (no binary asset needed), via the Web Audio API.
//   - ringtone : incoming call, two short beeps every 2.5 s
//   - ringback : outgoing call, one soft long tone every 3 s (what the caller hears)
//   - chime    : three ascending notes, to test the speakers
// Autoplay may be blocked until the user has interacted with the page —
// failures are ignored, every sound is best-effort.

let ctx = null
let ringTimer = null
let ringbackTimer = null

function ensureCtx () {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext
    if (!AC) return null
    ctx = new AC()
  }
  if (ctx.state === 'suspended') ctx.resume()
  return ctx
}

function beep (audioCtx, frequency, startTime, duration, volume) {
  const osc = audioCtx.createOscillator()
  const gain = audioCtx.createGain()
  osc.type = 'sine'
  osc.frequency.value = frequency
  gain.gain.setValueAtTime(0.0001, startTime)
  gain.gain.exponentialRampToValueAtTime(volume || 0.25, startTime + 0.05)
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration)
  osc.connect(gain).connect(audioCtx.destination)
  osc.start(startTime)
  osc.stop(startTime + duration)
}

export function startRingtone () {
  try {
    const c = ensureCtx()
    if (!c || ringTimer) return
    const ring = () => {
      const t = c.currentTime
      beep(c, 880, t, 0.35)
      beep(c, 880, t + 0.5, 0.35)
    }
    ring()
    ringTimer = setInterval(ring, 2500)
  } catch (e) { /* ignore — ringtone is best-effort */ }
}

export function stopRingtone () {
  if (ringTimer) { clearInterval(ringTimer); ringTimer = null }
}

export function startRingback () {
  try {
    const c = ensureCtx()
    if (!c || ringbackTimer) return
    const ring = () => beep(c, 440, c.currentTime, 1.1, 0.1)
    ring()
    ringbackTimer = setInterval(ring, 3000)
  } catch (e) { /* ignore */ }
}

export function stopRingback () {
  if (ringbackTimer) { clearInterval(ringbackTimer); ringbackTimer = null }
}

// Speaker test. `sinkId` (an audiooutput deviceId) is honoured where the
// browser supports AudioContext.setSinkId (Chrome 110+); elsewhere the chime
// plays on the default output.
export async function playTestChime (sinkId) {
  const AC = window.AudioContext || window.webkitAudioContext
  if (!AC) return false
  const c = new AC()
  try {
    if (sinkId && typeof c.setSinkId === 'function') {
      try { await c.setSinkId(sinkId) } catch (e) { /* unknown sink: default output */ }
    }
    if (c.state === 'suspended') await c.resume()
    const notes = [523.25, 659.25, 783.99]
    notes.forEach((f, i) => beep(c, f, c.currentTime + (i * 0.2), 0.55, 0.22))
    setTimeout(() => { try { c.close() } catch (e) { /* noop */ } }, 1800)
    return true
  } catch (e) {
    try { c.close() } catch (e2) { /* noop */ }
    return false
  }
}

export default { startRingtone, stopRingtone, startRingback, stopRingback, playTestChime }
